/* tslint:disable */
/* eslint-disable */
/**
 * Autom8.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {exists} from '../runtime';
import {Workflow, WorkflowFromJSON, WorkflowToJSON,} from './Workflow';

/**
 *
 * @export
 * @interface WorkflowIReadOnlyCollectionApiResult
 */
export interface WorkflowIReadOnlyCollectionApiResult {
    /**
     *
     * @type {boolean}
     * @memberof WorkflowIReadOnlyCollectionApiResult
     */
    success?: boolean;
    /**
     *
     * @type {Array<Workflow>}
     * @memberof WorkflowIReadOnlyCollectionApiResult
     */
    content?: Array<Workflow> | null;
    /**
     *
     * @type {string}
     * @memberof WorkflowIReadOnlyCollectionApiResult
     */
    message?: string | null;
}

export function WorkflowIReadOnlyCollectionApiResultFromJSON(json: any): WorkflowIReadOnlyCollectionApiResult {
    return WorkflowIReadOnlyCollectionApiResultFromJSONTyped(json, false);
}

export function WorkflowIReadOnlyCollectionApiResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): WorkflowIReadOnlyCollectionApiResult {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {

        'success': !exists(json, 'success') ? undefined : json['success'],
        'content': !exists(json, 'content') ? undefined : (json['content'] === null ? null : (json['content'] as Array<any>).map(WorkflowFromJSON)),
        'message': !exists(json, 'message') ? undefined : json['message'],
    };
}

export function WorkflowIReadOnlyCollectionApiResultToJSON(value?: WorkflowIReadOnlyCollectionApiResult | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {

        'success': value.success,
        'content': value.content === undefined ? undefined : (value.content === null ? null : (value.content as Array<any>).map(WorkflowToJSON)),
        'message': value.message,
    };
}

